export const maybePluralize = (length: number, singular: string, plural: string) =>
  length !== 1 ? plural : singular
export const maybePluralizeWithNum = (length: number, singular: string, plural: string) =>
  `${length} ${maybePluralize(length, singular, plural)}`
